/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1NotificationMobileAppNotificationidDetails200,
  GetApiV1NotificationMobileAppNotificationidDetails401,
  GetApiV1NotificationMobileAppNotificationidDetails404,
  GetApiV1NotificationMobileAppNotificationidDetails500,
  GetApiV1NotificationMobileAppNotificationidDetailsPathParams,
  GetApiV1NotificationMobileAppNotificationidDetailsQueryResponse,
} from "../../types/notificationMobileAppController/GetApiV1NotificationMobileAppNotificationidDetails.ts";
import { mobileNotificationDetailsViewModelSchema } from "../mobileNotificationDetailsViewModelSchema.ts";

export const getApiV1NotificationMobileAppNotificationidDetailsPathParamsSchema =
  z.object({
    notificationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1NotificationMobileAppNotificationidDetailsPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1NotificationMobileAppNotificationidDetails200Schema =
  z.lazy(
    () => mobileNotificationDetailsViewModelSchema,
  ) as unknown as ToZod<GetApiV1NotificationMobileAppNotificationidDetails200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1NotificationMobileAppNotificationidDetails401Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileAppNotificationidDetails401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1NotificationMobileAppNotificationidDetails404Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileAppNotificationidDetails404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1NotificationMobileAppNotificationidDetails500Schema =
  z.any() as unknown as ToZod<GetApiV1NotificationMobileAppNotificationidDetails500>;

export const getApiV1NotificationMobileAppNotificationidDetailsQueryResponseSchema =
  z.lazy(
    () => getApiV1NotificationMobileAppNotificationidDetails200Schema,
  ) as unknown as ToZod<GetApiV1NotificationMobileAppNotificationidDetailsQueryResponse>;
